<div class="alert d-flex align-items-center" [ngClass]="{ 'alert-app': isApp }">
    <span>{{"pt.edp.edponline.alert.invoicing" | translate }}</span>
    <button type="button" class="close" (click)="close()">
        <i class="icon-edponline-Bop-071" aria-hidden="true"></i>
    </button>
</div>